import { render, staticRenderFns } from "./ClientInformation.vue?vue&type=template&id=4b7bbc6f&scoped=true"
import script from "./ClientInformation.vue?vue&type=script&lang=ts"
export * from "./ClientInformation.vue?vue&type=script&lang=ts"
import style0 from "./ClientInformation.vue?vue&type=style&index=0&id=4b7bbc6f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7bbc6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7bbc6f')) {
      api.createRecord('4b7bbc6f', component.options)
    } else {
      api.reload('4b7bbc6f', component.options)
    }
    module.hot.accept("./ClientInformation.vue?vue&type=template&id=4b7bbc6f&scoped=true", function () {
      api.rerender('4b7bbc6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/CarePlanSteps/ClientInformation.vue"
export default component.exports